import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  height: 32px;
  margin: 16px 0 16px 0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-weight: bold;
`;

export const BreadcrumbPath = styled.div`
  font-size: ${props => props.theme.fontSize.fs10};
`;

export const BreadcrumbDivider = styled.div`
  padding: 0 8px;
`;